import {
  Box,
  FormGroup,
  Grid,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import PropTypes from "prop-types";

import { CardCvc } from "../cardCvc";
import { CardExpiry } from "../cardExpiry";
import { CardNumber } from "../cardNumber";

import { CreditCardIcon, UserIcon } from "../../../shared/icons";
import { useStyles } from "./style";

export const PaymentForm = ({
  formValues,
  incompleteCard,
  handleChange,
  errorValues,
  isFullEnrollPromotionCode,
}) => {
  const classes = useStyles();
  const firstNameError = "First Name is required";
  const lastNameError = "Last Name is required";

  return (
    <form className={[classes.form].join(" ")} noValidate>
      <Grid>
        <Box display="flex">
          <UserIcon />
          <Typography className={classes.subtitle} variant="h5" component="div">
            Payment information
          </Typography>
        </Box>
        <FormGroup className={classes.formGroup}>
          <InputLabel id="name" error={errorValues.name.hasErrorName}>
            First Name
          </InputLabel>
          <OutlinedInput
            disabled
            error={errorValues.name.hasErrorName}
            fullWidth
            name="name"
            label="First Name"
            labelWidth={3}
            id="name"
            autoComplete="current-name"
            placeholder="Katie"
            value={formValues?.name}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                {errorValues.name.hasErrorName && (
                  <CancelIcon className={classes.iconError} />
                )}
              </InputAdornment>
            }
          />
          <Typography className={classes.errorText} id="error-name">
            {errorValues.name.hasErrorName ? firstNameError : ""}
          </Typography>
        </FormGroup>
        <FormGroup className={classes.formGroup}>
          <InputLabel
            id="lastName"
            error={errorValues.lastName.hasErrorLastName}
          >
            Last Name
          </InputLabel>
          <OutlinedInput
            disabled
            error={errorValues.lastName.hasErrorLastName}
            fullWidth
            name="lastName"
            label="Last Name"
            id="lastName"
            autoComplete="current-lastName"
            placeholder="Richardson"
            value={formValues?.lastName}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                {errorValues.lastName.hasErrorLastName && (
                  <CancelIcon className={classes.iconError} />
                )}
              </InputAdornment>
            }
          />
          <Typography className={classes.errorText} id="error-lastname">
            {errorValues.lastName.hasErrorLastName ? lastNameError : ""}
          </Typography>
        </FormGroup>
        <FormGroup className={classes.formGroup}>
          <InputLabel id="email" error={errorValues.email.hasErrorEmail}>
            Email
          </InputLabel>
          <OutlinedInput
            error={errorValues.email.hasErrorEmail}
            fullWidth
            disabled
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
            placeholder="youremail@address.com"
            value={formValues?.email}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                {errorValues.email.hasErrorEmail && (
                  <CancelIcon className={classes.iconError} />
                )}
              </InputAdornment>
            }
          />
          <Typography className={classes.errorText} id="error-email">
            {errorValues.email.message ?? ""}
          </Typography>
        </FormGroup>
      </Grid>
      <Grid>
        <Box display="flex">
          <CreditCardIcon />
          <Typography className={classes.subtitle} variant="h5" component="div">
            Card details
          </Typography>
        </Box>
        <FormGroup>
          <InputLabel
            variant="standard"
            htmlFor="mobile"
            className={classes.bottom}
            disabled={isFullEnrollPromotionCode}
          >
            Card Number
          </InputLabel>
          <CardNumber disabled={isFullEnrollPromotionCode} />
        </FormGroup>
        <Box className={classes.group}>
          <FormGroup>
            <InputLabel
              variant="standard"
              htmlFor="mobile"
              className={classes.bottom}
              disabled={isFullEnrollPromotionCode}
            >
              Date
            </InputLabel>
            <CardExpiry disabled={isFullEnrollPromotionCode} />
          </FormGroup>
          <FormGroup>
            <InputLabel
              variant="standard"
              htmlFor="mobile"
              className={classes.bottom}
              disabled={isFullEnrollPromotionCode}
            >
              CVC
            </InputLabel>
            <CardCvc disabled={isFullEnrollPromotionCode} />
          </FormGroup>
        </Box>
      </Grid>

      {incompleteCard.length > 0 && (
        <span className={classes.errorStripe}>{incompleteCard}</span>
      )}
    </form>
  );
};

PaymentForm.propTypes = {
  formValues: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    lastName: PropTypes.string,
    profileId: PropTypes.string,
    subscriptionStatus: PropTypes.string,
  }).isRequired,
  incompleteCard: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  errorValues: PropTypes.shape({
    email: PropTypes.shape({
      hasErrorEmail: PropTypes.bool,
      message: PropTypes.string,
    }),
    name: PropTypes.shape({
      hasErrorName: PropTypes.bool,
      message: PropTypes.string,
    }),
    lastName: PropTypes.shape({
      hasErrorLastName: PropTypes.bool,
      message: PropTypes.string,
    }),
    priceId: PropTypes.shape({
      hasErrorPriceId: PropTypes.bool,
      message: PropTypes.string,
    }),
  }).isRequired,
  isFullEnrollPromotionCode: PropTypes.bool.isRequired,
};

PaymentForm.displayName = "PaymentForm";
